import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Combos/getComboTipoDosisGranja`, method: 'POST', body: values, token: token})
}
